import PropTypes from "prop-types";
import * as React from "react";
import { Interpolate } from "react-i18next";
import { TooltipRank } from "UIKit";
import { Tooltip, TooltipBody } from "Components/UIKit/components";

import { unixToFormattedLocalDate, unixToFormattedLocalTime } from "helpers/datetime";
import { t, x } from "helpers/localization";

export const ClanIsDisbandedTooltip = () => <Tooltip id={ClanIsDisbandedTooltip.id}>
    <TooltipBody>
        {t('Клан распущен')}
    </TooltipBody>
</Tooltip>;
ClanIsDisbandedTooltip.id = 'clan-is-dissolved-tooltip';

export const ClanMembersInfoMissingTooltip = () => <Tooltip id={ClanMembersInfoMissingTooltip.id}>
    <TooltipBody>
        {t('Не удалось получить информацию об игроках клана')}
    </TooltipBody>
</Tooltip>;
ClanMembersInfoMissingTooltip.id = 'clan-members-info-missing-tooltip';

export const MemberInfoMissingTooltip = () => <Tooltip id={MemberInfoMissingTooltip.id}>
    <TooltipBody>
        {t('Не удалось получить информацию об игроке')}
    </TooltipBody>
</Tooltip>;
MemberInfoMissingTooltip.id = 'member-info-missing-tooltip';

export const MemberIsBannedTooltip = () => <Tooltip id={MemberIsBannedTooltip.id}>
    <TooltipBody>
        {t('Аккаунт игрока заблокирован')}
    </TooltipBody>
</Tooltip>;
MemberIsBannedTooltip.id = 'member-is-banned-tooltip';

export const ClanWalletMissingTooltip = () => <Tooltip id={ClanWalletMissingTooltip.id}>
    <TooltipBody>
        {t('Не удалось получить данные о количестве баррелей нефти:tooltip')}
    </TooltipBody>
</Tooltip>;
ClanWalletMissingTooltip.id = 'clan-wallet-missing-tooltip';

export const LastBattleTimeTooltipContent = date => <TooltipBody>
    <Interpolate useDangerouslySetInnerHTML={true} i18nKey={x('Последний бой: %(date)s&nbsp;в&nbsp;%(time)s')} date={unixToFormattedLocalDate(date)} time={unixToFormattedLocalTime(date)} />
</TooltipBody>;

export const RankTooltipContent = props => <TooltipBody>
    <TooltipRank rank={props.rank} seasonId={props.seasonId} seasonRank={props.seasonRank} />
</TooltipBody>;
RankTooltipContent.propTypes = {
    rank: PropTypes.number,
    seasonId: PropTypes.number,
    seasonRank: PropTypes.number
};


export const ClanDescriptionButtonTooltip = () => <TooltipBody>
    {t('Нажмите, чтобы открыть описание клана:tooltip')}
</TooltipBody>;